import fetch from  '@/api/fetch';

/** 根据企业id获取企业信息 */
export const getOrgById = orgId => fetch.get(`/index/org/id/${orgId}`);

/** 获取项目、企业标签 */
export const getProjectOrgLabel = params => fetch.get(`/index/pro/org/label`, { params });

/** 获取当前用户的企业切换列表 */
export const getCurrentPcOrgs = _ => fetch.get('/index/orgs/pc')



/** 切换企业) */
export const switchOrgOrSys = orgSwitch => fetch.post('/index/switchOrgOrSys', orgSwitch)

/** 根据typeCode查询下级 */
export const getItemByTypeCode = typeCode => fetch.get(`/item/typeCode/${typeCode}`);


/**获取所有工资状态枚举 */
export const getSilpEnumAll = () => fetch.get('/index/wage/status/all');

